module.exports = __webpack_public_path__ + "edc868a598bce7a8b845c030762eb4ce.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-25.png
// module id = 3150
// module chunks = 0